import { render, staticRenderFns } from "./automodal.vue?vue&type=template&id=a615c7c8&scoped=true&"
import script from "./automodal.vue?vue&type=script&lang=js&"
export * from "./automodal.vue?vue&type=script&lang=js&"
import style0 from "./automodal.vue?vue&type=style&index=0&id=a615c7c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a615c7c8",
  null
  
)

export default component.exports